import axios from 'axios';
import { CONTENT_TYPES, HEADERS } from '../constants/strings';
import { ENDPOINTS } from '../constants/apiEndpoints';
import { logout } from '../redux/authSlice';

let storeDispatch = null;
let appNavigate = null;

const api = axios.create({
  withCredentials: true,
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': CONTENT_TYPES.json,
  },
});

// Setup function to inject dispatch and navigate from React context
export const setupAxiosInterceptors = (dispatch, navigate) => {
  storeDispatch = dispatch;
  appNavigate = navigate;
};


api.interceptors.request.use((config) => {
  const matchedEndpoint = Object.values(ENDPOINTS).find(endpoint => endpoint.url === config.url);

  if (matchedEndpoint?.secure === false) {
    if (config.headers[HEADERS.cookie]) {
      delete config.headers[HEADERS.cookie];
    }
    config.withCredentials = false;
  }else{
    if((process.env.REACT_APP_ENV === 'local' || process.env.REACT_APP_ENV === 'development')){
      config.headers[HEADERS.authorization] = sessionStorage.getItem('token');
    }else{
      config.withCredentials = true;
    }
  }

  return config;
});

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
     if (error.response?.status === 401) {
      // Handle unauthorized access, e.g., redirect to login
           console.warn('Unauthorized. Logging out...');
      storeDispatch(logout());
      appNavigate('/', { replace: true });
    } else if (error.response?.status === 400) {
      // Handle bad request, e.g., show an error message
      console.error('Bad request:', error.response.data.message); 
    } else if (error.response?.status === 403) {
      // Handle forbidden access, e.g., show an error message
      console.error('Access forbidden:', error.response.data.message);
    } else if (error.response?.status === 404) {
      // Handle not found error, e.g., show a 404 page
      console.error('Resource not found:', error.response.data.message);
    } else if (error.response?.status >= 500) {
      // Handle server errors, e.g., show a generic error message
      console.error('Server error:', error.response.data.message);
    } else {
      // Handle other types of errors
      console.error('An error occurred:', error.message); 
     }
    return Promise.reject(error);
  }
);

export default api;
